<script>
    import { createEventDispatcher } from 'svelte'
    import { fade } from 'svelte/transition'

    const dispatch = createEventDispatcher()

    export let type = 'error'
    export let dismissible = true
</script>

<div class="toast d-flex align-items-center bg-{type} text-white m-1" role="alert" aria-live="assertive" aria-atomic="true" transition:fade>
    <div class="d-flex w-100">

        <div class="toast-body">
            <slot />
        </div>
        {#if dismissible}
        <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Fermer" on:click={() => dispatch('dismiss')}></button>
        {/if}
    </div>

</div>

